import { _formatDate } from "../../utils/helpers/dateHelpers";

export interface IDispositivoActualizarFechaDevolucion {
  dispositivoAsignadoId: string;
}
export interface IModeloDispositovoPorPersona {
  personaId: string | undefined;
  search: string;
}
export interface IModeloEquipoDelete {
  personaId: string;
  equipoModeloId: string;
}

export interface IFilterReporteDispositivoAsignado {
  fechaEntregaInicio: string | null;
  fechaEntregaFin: string | null;
  guardia?: string | null;
  areaId: string | null;
}

export const initialFilterReporteDispositivoAsignado: IFilterReporteDispositivoAsignado =
{
  fechaEntregaInicio: null,
  fechaEntregaFin: null,
  guardia: null,
  areaId: null,
};
export interface IFilterDispositivosAsignados {
  skip: number;
  take: number;
  search?: string | undefined;
  fechaEntregaInicio?: string | null;
  fechaEntregaFin?: string | null;
  guardia?: string | null;
  areaId: string | null;
}

export const initFiliterDispositivosAsigandos: IFilterDispositivosAsignados = {
  skip: 0,
  take: 50,
  search: "",
  fechaEntregaInicio: null,
  fechaEntregaFin: null,
  guardia: null,
  areaId: null,
};

export interface IDateFilter {
  date?: Date | undefined;
  guardia?: string | undefined;
}

export interface IFilterDispositivoHistorico {
  skip: number;
  take: number;
  search?: string | null;
  fechaInicio?: string | null;
  fechaFin?: string | null;
  guardia?: string | null;
  areaId?: string | null;
}
export const InitialFilterDispositivoHistorico: IFilterDispositivoHistorico = {
  skip: 0,
  take: 50,
  search: "",
  fechaInicio: "",
  fechaFin: _formatDate(new Date(), ","),
  guardia: null,
  areaId: null,
};
export interface IFilterReporteDispositivoHistorico {
  fechaInicio?: string | null;
  fechaFin?: string | null;
  guardia?: string | null;
  areaId?: string | null;
}

export const InitialFilterReporte: IFilterReporteDispositivoHistorico = {
  fechaInicio: "",
  fechaFin: _formatDate(new Date(), ","),
  areaId: null,
  guardia: "",
};
